import { MobileDrawer } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React from 'react';
import s from './MobileDrawerWrapper.scss';
import { classes as stClasses } from './MobileDrawerWrapper.st.css';
export const MobileDrawerWrapper = _ref => {
  let {
    isOpen,
    onRequestClose,
    children,
    dataHook,
    focusTrap = true,
    hostId,
    mobileDrawerClassName,
    contentContainerClassName
  } = _ref;
  return /*#__PURE__*/React.createElement(MobileDrawer, {
    onRequestClose: onRequestClose,
    className: classNames(s.root, stClasses.mobileDrawer, mobileDrawerClassName, hostId),
    "data-hook": dataHook,
    focusTrap: focusTrap,
    isOpen: isOpen,
    appendToBody: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(s.stopBodyYScroll, s.contentContainer, contentContainerClassName)
  }, children));
};
//# sourceMappingURL=MobileDrawerWrapper.js.map